import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from 'store'

interface ChatState {
  startChat: boolean
  chatToken: string
  patientEmail: string
  appointmentId: string
  videoChatStyle: string
  patientName: string
  patientId: string
}

const initialState: ChatState = {
  startChat: false,
  chatToken: '',
  patientEmail: '',
  appointmentId: '',
  videoChatStyle: 'defaultStyle',
  patientName: '',
  patientId: '',
}

const videoChatSlice = createSlice({
  name: 'videoChat',
  initialState,
  reducers: {
    startChatAction: (state, { payload }: PayloadAction<boolean>) => {
      state.startChat = payload
    },

    setChatTokenAction: (state, { payload }: PayloadAction<string>) => {
      state.chatToken = payload
    },
    setPatientEmailAction: (state, { payload }: PayloadAction<string>) => {
      state.patientEmail = payload
    },
    setAppointmentIdAction: (state, { payload }: PayloadAction<string>) => {
      state.appointmentId = payload
    },
    setVideoChatStyleAction: (state, { payload }: PayloadAction<string>) => {
      state.videoChatStyle = payload
    },
    setPatientNameAction: (state, { payload }: PayloadAction<string>) => {
      state.patientName = payload
    },
    setPatientIdAction: (state, { payload }: PayloadAction<string>) => {
      state.patientId = payload
    },
  },
})

export const {
  startChatAction,
  setChatTokenAction,
  setPatientEmailAction,
  setAppointmentIdAction,
  setVideoChatStyleAction,
  setPatientNameAction,
  setPatientIdAction,
} = videoChatSlice.actions

export const startVideoChat = (start: boolean): AppThunk => async (dispatch) => {
  dispatch(startChatAction(start))
}

export const setChatToken = (chatToken: string): AppThunk => async (dispatch) => {
  dispatch(setChatTokenAction(chatToken))
}

export const setPatientEmail = (patientEmail: string): AppThunk => async (dispatch) => {
  dispatch(setPatientEmailAction(patientEmail))
}

export const setAppointmentId = (appointmentId: string): AppThunk => async (dispatch) => {
  dispatch(setAppointmentIdAction(appointmentId))
}

export const setVideoChatStyle = (videoChatStyle: string): AppThunk => async (dispatch) => {
  dispatch(setVideoChatStyleAction(videoChatStyle))
}

export const setPatientName = (patientName: string): AppThunk => async (dispatch) => {
  dispatch(setPatientNameAction(patientName))
}

export const setPatientId = (patientId: string): AppThunk => async (dispatch) => {
  dispatch(setPatientIdAction(patientId))
}

export default videoChatSlice.reducer
